<template>
  <div class="root" id="products">
    <div class="shop-box">
      <div class="title">FLORENGE</div>
      <div class="subtitle">{{ selectedVariant.name }}</div>
      <div class="choose-variant-prompt">Chọn phối màu ưa thích của bạn</div>
      <div class="variant-selector-component">
        <VariantSelector :isWideLayout="true" />
      </div>
    </div>
    <div class="product-box">
      <div class="product-image-box">
        <div class="left-arrow" @click="prevProductImage">
          <img src="@/assets/left-arrow.svg" alt="prev" />
        </div>
        <div class="right-arrow" @click="nextProductImage">
          <img src="@/assets/right-arrow.svg" alt="next" />
        </div>
        <swiper ref="productSwiper" :options="productSwiperOptions">
          <swiper-slide class="product-image-slide">
            <img
              :src="selectedVariant.thumbnail"
              alt="product thumbnail"
              class="product-image"
            />
          </swiper-slide>
          <swiper-slide class="product-image-slide">
            <img
              :src="selectedVariant.thumbnailAlt"
              alt="product thumbnail"
              class="product-image"
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="price-section">
        <button class="price-button" @click="redirectToCurnon">
          <div class="leftText">MUA NGAY</div>
          <div class="rightText">
            <span class="discounted">{{
              selectedVariant.priceDiscounted | priceVndFormat
            }}</span>
            <span class="original">{{
              selectedVariant.price | priceVndFormat
            }}</span>
          </div>
        </button>
      </div>
    </div>
    <div class="gallery-box">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide
          v-for="(item, idx) in selectedVariant.galleryItems"
          :key="idx"
        >
          <img :src="item" alt="gallery item" class="gallery-item" />
        </swiper-slide>

        <div class="swiper-pagination hide-on-mobile" slot="pagination"></div>
        <div class="left-arrow" @click="prevGalleryImage" slot="button-prev">
          <img src="@/assets/left-arrow-white.svg" alt="prev" />
        </div>
        <div class="right-arrow" @click="nextGalleryImage" slot="button-next">
          <img src="@/assets/right-arrow-white.svg" alt="next" />
        </div>
      </swiper>
    </div>
    <CoolLightBox
      :items="lightBoxItems"
      :index="galleryIndex"
      loop
      @close="handleHide"
    >
    </CoolLightBox>
  </div>
</template>

<script>
import VariantSelector from "@/components/variantSelector/variantSelector";
import { mapGetters } from "vuex";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
export default {
  name: "fold3",
  components: { VariantSelector },
  watch: {
    selectedVariant: function () {
      this.swiper.slideTo(0);
      this.swiper.autoplay.start();
      this.galleryIndex = null;
    },
  },
  computed: {
    lightBoxItems() {
      return this.selectedVariant.galleryItems.map((el) => ({ src: el }));
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    productSwiper() {
      return this.$refs.productSwiper.$swiper;
    },
    ...mapGetters({
      selectedVariant: "selectedVariant",
    }),
  },
  methods: {
    handleHide() {
      this.galleryIndex = null;
    },
    showImg(idx) {
      this.galleryIndex = idx;
    },
    nextProductImage() {
      this.productSwiper.slideNext();
    },
    prevProductImage() {
      this.productSwiper.slidePrev();
    },
    nextGalleryImage() {
      this.swiper.slideNext();
    },
    prevGalleryImage() {
      this.swiper.slidePrev();
    },
    redirectToCurnon() {
      window.location.href =
        "https://curnonwatch.com/dong-ho/dong-ho-nu/dong-ho-nu-florenge";
    },
  },
  data() {
    return {
      galleryIndex: null,
      productSwiperOptions: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination hide-on-desktop",
        },
      },
      swiperOptions: {
        slidesPerView: 2,
        loop: true,
        on: {
          click: () => {
            if (this.swiper.realIndex !== undefined) {
              const wSize = window.matchMedia("(min-width:1024px)");
              if (wSize.matches) {
                this.showImg(this.swiper.realIndex % 2);
              } else {
                this.showImg((this.swiper.realIndex + 1) % 2);
              }
            }
          },
        },
        pagination: {
          el: ".swiper-pagination",
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"> </span>`;
          },
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            autoplay: {
              delay: 3500,
              disableOnInteraction: false,
            },
          },
        },
      },
    };
  },
};
</script>
<style lang="scss">
@keyframes pulsing {
  to {
    box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
  }
}

.swiper-pagination-bullet-custom {
  background: rgba(255, 255, 255, 0);
  font-weight: bold;
  height: 12px;
  width: 12px;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  border: 1px solid #ffffff;
  margin-bottom: 4px !important;
  &.swiper-pagination-bullet-active {
    background: rgba(255, 255, 255, 0.9);
    height: 20px;
    width: 20px;
    margin-bottom: 0px !important;
  }
}
.swiper-pagination {
  /* position: relative; */
}
</style>
<style lang="scss" scoped>
.hide-on-mobile {
  display: none;
}
.root {
  background: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;

  .shop-box {
    padding-top: 48px;
    .title {
      font-family: "Rollgates Fabulous", sans-serif;
      font-style: italic;
      font-size: 48px;
      line-height: 54px;
      text-align: center;
      color: #000000;
    }
    .subtitle {
      font-family: "SVN-Gotham", sans-serif;
      font-weight: 300;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 1em;
      text-transform: uppercase;
      color: #d35c34;
    }
    .choose-variant-prompt {
      margin-top: 48px;
      font-family: "SVN-Gotham", sans-serif;
      font-weight: 300;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */

      text-align: center;
      letter-spacing: 0.03em;

      color: #000000;
    }
    .variant-selector-component {
      padding-top: 24px;
    }
  }
  .product-box {
    padding: 16px;
    .product-image-box {
      position: relative;
      background: #f5f5f5;
      height: 100vw;
      .left-arrow {
        position: absolute;
        top: 50%;
        left: 0;
        padding: 8px;
        z-index: 3;
        transition: 0.3s ease all;
        &:hover {
          transform: translateX(-2px);
        }
      }
      .right-arrow {
        position: absolute;
        top: 50%;
        right: 0;
        padding: 8px;
        z-index: 3;
        transition: 0.3s ease all;
        &:hover {
          transform: translateX(2px);
        }
      }
      .left-arrow,
      .right-arrow {
        cursor: pointer;
      }
      .product-image-slide {
        .product-image {
          width: 100%;
          height: 100vw;
          object-fit: contain;
          display: block;
        }
      }
    }
    .price-button {
      font-family: "SVN-Gotham", sans-serif;
      font-weight: 500;
      width: 100%;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0.03em;
      border: none;
      background: #d35c34;
      padding: 24px;
      display: flex;
      color: #ffffff;
      justify-content: space-between;
      box-shadow: 0 0 0 0 rgba(232, 76, 61, 0.7);
      transition: all 300ms ease-in-out;
      cursor: pointer;
      animation: pulsing 2s infinite cubic-bezier(0.66, 0, 0, 1);
      display: flex;
      align-items: center;
      .leftText {
      }
      .rightText {
        display: flex;
        flex-direction: column;
        .original {
          padding-top: 8px;
          font-size: 10px;
          line-height: 10px;
          /* identical to box height, or 100% */

          text-align: right;
          letter-spacing: 0.03em;
          text-decoration-line: line-through;

          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
  .gallery-box {
    padding: 0 8px;
    position: relative;
    .gallery-item {
      width: 100%;
      max-height: 50vw;
      padding: 8px;
      box-sizing: border-box;
      object-fit: cover;
      object-position: center;
      cursor: pointer;
    }
    .left-arrow {
      position: absolute;
      left: 50%;
      bottom: 16px;
      transform: translateX(-60px);
      z-index: 11;
      cursor: pointer;
    }
    .right-arrow {
      position: absolute;
      right: 50%;
      bottom: 16px;
      transform: translateX(60px);
      z-index: 11;
      cursor: pointer;
    }
    .left-arrow,
    .right-arrow {
      display: none;
    }
  }
}
@media (min-width: 1024px) {
  .hide-on-mobile {
    display: initial;
  }
  .root {
    position: relative;
    display: flex;
    .shop-box {
      width: 50%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transform: translateX(-15%);
    }
    .product-box {
      z-index: 3;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      .product-image-box {
        width: 360px;
        height: 360px;
        .product-image-slide {
          .product-image {
            width: 360px;
            height: 360px;
          }
        }
      }
    }
    .gallery-box {
      flex: 1;
      padding: 0;
      width: 50%;
      .gallery-item {
        padding: 0;
      }
      .left-arrow,
      .right-arrow {
        display: initial;
      }
    }
  }
}
</style>
